// Tiny preact hook: re-render the calling component on any store change.
// Components import { state } directly for reads; this just triggers the
// repaint when state mutates. For now it's a coarse "re-render on anything";
// we can add selectors later if any panel becomes a perf hotspot.
import { useEffect, useState } from 'preact/hooks';
import { subscribe } from '../systems/store.js';

export function useStore() {
  const [, force] = useState(0);
  useEffect(() => subscribe(() => force(n => n + 1)), []);
}
